circleLoader.directive('zCircleLoader', [
    'templateCache',
    'helperService',
    function (templateCache, helperService) {
        return {
            restrict: 'E',
            template: templateCache.getTemplate(
                'circle_loader/templates/' + helperService.getRedesignPathPrefix() + 'circleLoader.html'
            ),
            replace: true,
            scope: {
                type: '@?' /*spinner | loader | percent-loader */,
                completion: '=?',
                duration: '=?' /*in ms*/,
                resetLoader: '=?',
                size: '=?'
            },
            controller: 'circleLoaderCtrl',
            controllerAs: 'circleLoader',
            bindToController: true
        };
    }
]);
